import { create } from "zustand";

import type { ArtifactInfos, ChatMessage } from "@virtual-brain-lib/types";

export interface OpenedArtifact {
	artifactId: ArtifactInfos["id"];
	artifactName?: string;
	assistantMessageId: ChatMessage["id"];
	userMessageId: ChatMessage["id"];
	userMessageContent: string;
}

type OpenedArtifactStore = {
	openedArtifact?: OpenedArtifact;
	setOpenedArtifact: (openedArtifact?: OpenedArtifact) => void;
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;
	isRetrying: boolean;
	setIsRetrying: (isRetrying: boolean) => void;
	reset: () => void;
};

export const useOpenedArtifactStore = create<OpenedArtifactStore>((set) => ({
	openedArtifact: undefined,
	isLoading: true,
	isRetrying: false,
	setOpenedArtifact(value) {
		set({ openedArtifact: value });
	},
	setIsLoading(value) {
		set({ isLoading: value });
	},
	setIsRetrying(value) {
		set(value ? { isRetrying: true, openedArtifact: undefined } : { isRetrying: false });
	},
	reset() {
		set({ openedArtifact: undefined, isLoading: true, isRetrying: false });
	},
}));
